import { useEffect, useMemo } from "react";
import useUserGroups, { UserGroup } from "./useUserGroups";

/**
 * Custom hook for loading and formatting team options for evals.
 * Automatically loads all teams on mount and provides formatted options.
 */
export const useTeamOptions = () => {
  const {
    groups,
    isLoading: teamsLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useUserGroups();

  // Load all teams on mount
  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

  // Team options for combobox
  const teamOptions = useMemo(() => {
    const options = groups.map((group: UserGroup) => ({
      label: group.name,
      value: group.id,
    }));

    // Add "No Team" option at the beginning
    options.unshift({ label: "No Team (Use Dashboard Selection)", value: "" });

    return options;
  }, [groups]);

  return {
    teamOptions,
    teamsLoading,
  };
};
